export default {
    methods: {
        partitionPath: (name, length, count) => {
            let path = '';
            for (let i = 0; i < count; i++) {
                path += name.slice((i * length), (i * length) + length) + '/';
            }
            return path + name;
        },
        getKeyword: function (str) {
            str = str.trim();
            str = this.removeDiacritical(str);
            str = this.removeSpecialChar(str);
            str = this.stripMultiSpace(str);
            return str.toLowerCase();
        },
        createAlias: function (str) {
            str = str.trim();
            str = this.removeDiacritical(str);
            str = this.removeSpecialChar(str);
            str = this.stripMultiSpace(str);
            str = str.replace(/\s/g, '-');
            return str.toLowerCase();
        },
        removeDiacritical: function (str) {
            str = str.replace(/(à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ)/g, 'a');
            str = str.replace(/(è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ)/g, 'e');
            str = str.replace(/(ì|í|ị|ỉ|ĩ)/g, 'i');
            str = str.replace(/(ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ)/g, 'o');
            str = str.replace(/(ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ)/g, 'u');
            str = str.replace(/(ỳ|ý|ỵ|ỷ|ỹ)/g, 'y');
            str = str.replace(/(đ)/g, 'd');
            str = str.replace(/(À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ)/g, 'A');
            str = str.replace(/(È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ)/g, 'E');
            str = str.replace(/(Ì|Í|Ị|Ỉ|Ĩ)/g, 'I');
            str = str.replace(/(Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ)/g, 'O');
            str = str.replace(/(Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ)/g, 'U');
            str = str.replace(/(Ỳ|Ý|Ỵ|Ỷ|Ỹ)/g, 'Y');
            str = str.replace(/(Đ)/g, 'D');
            return str;
        },
        removeSpecialChar: function (str) {
            return str.replace(/[^A-Za-z0-9\-\s]/g, '');
        },
        stripMultiSpace: function (str) {
            return str.replace(/\s+/g, ' ');
        },
        seconds2time: function (seconds) {
            let hours = Math.floor(seconds / 3600);
            let minutes = Math.floor((seconds - (hours * 3600)) / 60);
            seconds = seconds - (hours * 3600) - (minutes * 60);
            let time = "";

            if (hours != 0) {
                time = hours + "h";
            }
            if (minutes != 0 || time !== "") {
                minutes = (minutes < 10 && time !== "") ? "0" + minutes : String(minutes);
                time += minutes + "m";
            }
            if (time === "") {
                time = seconds + "s";
            } else {
                time += ((seconds < 10) ? "0" + seconds : String(seconds)) + "s";
            }
            return time;
        },
        fancyTimeFormat: function (time) {
            // Hours, minutes and seconds
            var hrs = ~~(time / 3600);
            var mins = ~~((time % 3600) / 60);
            var secs = ~~time % 60;
            // Output like "01:01" or "04:03:59" or "123:03:59"
            var ret = "";
            if (hrs > 0) {
                ret += "" + hrs + ":";
            }
            ret += "" + (mins < 10 ? "0" + mins : mins) + ":" + (secs < 10 ? "0" : "");
            ret += "" + secs;
            return ret;
        },
        getMatchesParam(str){
            if(!str) return "";
            let matchStr = "";
            let paramObj = {};
            let rsArray = [];

            for(let i in str){
                if(str.charAt(i) === '{'){
                    matchStr = String(str.charAt(i));
                    continue;
                }

                if(matchStr.includes("{") && str.charAt(i) !== '}'){
                    matchStr = matchStr.concat(str.charAt(i));
                    continue;
                }

                if(matchStr.includes('{') && str.charAt(i) == '}'){
                    matchStr = matchStr.concat(str.charAt(i));

                    let configPart = matchStr.replace("{", "").replace("}", "").split(',');
                    if(!configPart || configPart.length != 2 || Number.isNaN(configPart[1]) || configPart[1].trim() == "" || configPart[0] === "")
                        continue;

                    paramObj["key"] = matchStr;
                    paramObj["value"] = configPart[1].trim();

                    rsArray.push(paramObj);
                    paramObj = {};
                    matchStr = '';
                }
            }
            return rsArray;
        },
    },
};